<template>
    <div class="navigation">
        <RouterLink @click="onRouterLinkClicked" :class="{selected:isSelected('/')}" to="/" class="home-link">
            <ZSIcon color="white" icon="Home"></ZSIcon>
            <span v-if="!collapsed">{{ t('navigation.home') }}</span>
        </RouterLink>
        <Accordion v-can="'cloud_licenses.view'" initiallyOpen defaultTitle="My Accordion Title" :disabled="collapsed">
            <template #header="{ isOpen }">
                <div class="nav-header">
                    <ZSIcon color="white" icon="Cloud"></ZSIcon>
                    <span v-if="!collapsed">{{ t('navigation.cloud_licenses') }}</span>
                    <ZSIcon v-if="!collapsed" color="white" style="margin-left:auto" :rotation="isOpen ? '180' : '0'"
                        icon="Chevron"></ZSIcon>
                </div>
            </template>
            <div class="nav-list" v-if="!collapsed">
                <!-- <RouterLink to="/">Home</RouterLink> -->
                <!-- <RouterLink :class="{selected:isSelected('/') || isSelected('/licenses')}" to="/">{{ t('navigation.licenses') }}</RouterLink> -->
                <RouterLink @click="onRouterLinkClicked" :class="{selected:isSelected('/license_list')}" to="/license_list">{{ t('navigation.licenses') }}</RouterLink>
                <RouterLink @click="onRouterLinkClicked" :class="{selected:isSelected('/pending_licenses')}" to="/pending_licenses">{{ t('navigation.pending_licenses') }}</RouterLink>
                <RouterLink @click="onRouterLinkClicked" :class="{selected:isSelected('/expired_licenses')}" to="/expired_licenses">{{ t('navigation.expired_licenses') }}</RouterLink>
            </div>
        </Accordion>
        <Accordion v-can="'local_licenses.view'" initiallyOpen defaultTitle="My Accordion Title" :disabled="collapsed">
            <template #header="{ isOpen }">
                <div class="nav-header">
                    <ZSIcon color="white" icon="cloudOff"></ZSIcon>
                    <span v-if="!collapsed">{{ t('navigation.non_cloud_licenses') }}</span>
                    <ZSIcon v-if="!collapsed" color="white" style="margin-left:auto" :rotation="isOpen ? '180' : '0'"
                        icon="Chevron"></ZSIcon>
                </div>
            </template>
            <div class="nav-list" v-if="!collapsed">
                <RouterLink @click="onRouterLinkClicked" :class="{selected:isSelected('/local_license_list')}" to="/local_license_list">{{ t('local_licenses.title') }}</RouterLink>
            </div>
        </Accordion>
         <Accordion v-can="'groups.view'" defaultTitle="My Accordion Title" :disabled="collapsed  || !isSelected('/license_list')">
            <template #header="{ isOpen }">
                <div :disabled="!isSelected('/license_list')" class="nav-header">
                    <ZSIcon color="white" icon="tag"></ZSIcon>
                    <span v-if="!collapsed">{{ t('tag.tags') }}</span>
                    <ZSIcon v-if="!collapsed" color="white" style="margin-left:auto" :rotation="isOpen ? '180' : '0'"
                        icon="Chevron"></ZSIcon>
                </div>
            </template>      
            <div class="nav-list" v-if="!collapsed">
                <TagPanel></TagPanel>
            </div>                  
         </Accordion>
        <!-- <Accordion v-if="user.admin" initiallyOpen defaultTitle="My Accordion Title" :disabled="collapsed">
            <template #header="{ isOpen }">
                <div class="nav-header">
                    <ZSIcon color="white" icon="userSettings"></ZSIcon>
                    <span v-if="!collapsed">{{ t('navigation.1') }}</span>
                    <ZSIcon v-if="!collapsed" color="white" style="margin-left:auto" :rotation="isOpen ? '180' : '0'"
                        icon="Chevron"></ZSIcon>
                </div>
            </template>
            <div class="nav-list" v-if="!collapsed">
                <RouterLink @click="onRouterLinkClicked" v-if="user.admin" :class="{selected:isSelected('/orders-state')}"  to="/orders-state">{{ t('navigation.orders-state') }}</RouterLink>
                <RouterLink @click="onRouterLinkClicked" v-if="user.admin" :class="{selected:isSelected('/hardware-request-status'),notify:hasNewHardware}"  to="/hardware-request-status">{{ t('navigation.hardware-request-status') }}</RouterLink>
            </div>
        </Accordion> -->
        <Accordion v-can="'leads.view'" initiallyOpen defaultTitle="My Accordion Title" :disabled="collapsed">
            <template #header="{ isOpen }">
                <div class="nav-header">
                    <ZSIcon color="white" icon="userStars"></ZSIcon>
                    <span v-if="!collapsed">{{ t('navigation.leads') }}</span>
                    <ZSIcon v-if="!collapsed" color="white" style="margin-left:auto" :rotation="isOpen ? '180' : '0'"
                        icon="Chevron"></ZSIcon>
                </div>
            </template>
            <div class="nav-list" v-if="!collapsed">
                <RouterLink @click="onRouterLinkClicked"  :class="{selected:isSelected('/leads')}"  to="/leads">{{ t('navigation.licenses') }}</RouterLink>
            </div>
        </Accordion>
        <Accordion v-can="'tech_resources.view'" initiallyOpen defaultTitle="Setups & Manuais" :disabled="collapsed">
            <template #header="{ isOpen }">
                <div class="nav-header">
                    <ZSIcon color="white" icon="userSettings"></ZSIcon>
                    <span v-if="!collapsed">{{ t('navigation.tecnical_resources') }}</span>
                    <ZSIcon v-if="!collapsed" color="white" style="margin-left:auto" :rotation="isOpen ? '180' : '0'"
                        icon="Chevron"></ZSIcon>
                </div>
            </template>
            <div class="nav-list" v-if="!collapsed">
                <RouterLink @click="onRouterLinkClicked" :class="{selected:isSelected('/manuals_setups')}"  to="/manuals_setups">{{ t('navigation.setups_manuals_utilities') }}</RouterLink>
                <RouterLink @click="onRouterLinkClicked" :class="{selected:isSelected('/release_notes')}" to="/release_notes">{{ t('navigation.release_notes') }}</RouterLink>
                <!-- Hidden: <RouterLink @click="onRouterLinkClicked" :class="{selected:isSelected('/moodle_users')}" to="/moodle_users">{{ t('navigation.moodle_users') }}</RouterLink> -->
                <!-- <a   target="blank" href="https://zsacademy.zonesoft.org/login/index.php">ZS Academy</a> -->
            </div>
        </Accordion>
        <Accordion v-can="'academy.view'" initiallyOpen defaultTitle="Setups & Manuais" :disabled="collapsed">
            <template #header="{ isOpen }">
                <div class="nav-header">
                    <!-- <ZSIcon color="white" icon="graduationCap"></ZSIcon> -->
                    <span v-if="!collapsed"><img style="max-height:25px;position:relative;top:5px;left:-5px" src="@/assets/ZSacademy_BW_Negative.png"></span>
                    <ZSIcon v-if="!collapsed" color="white" style="margin-left:auto" :rotation="isOpen ? '180' : '0'"
                        icon="Chevron"></ZSIcon>
                </div>
            </template>
            <div class="nav-list" v-if="!collapsed">
               <a   target="blank" href="https://zsacademy.zonesoft.org/login/index.php">{{ t('navigation.academy_login') }}</a>
               <!-- Hidden (old Google Form): <a   target="blank" href="https://forms.gle/KZCsesQKtLVLBEPs8">{{ t('navigation.academy_register') }}</a> -->
               <a   href="javascript:void(0)" @click="onOpenMoodleWizard">{{ t('navigation.academy_register') }}</a>
            </div>
        </Accordion>
    </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue'
import { useRoute } from 'vue-router';
import { RouterLink } from 'vue-router'
import { useI18n } from 'vue-i18n'
// import ZSIcon from '@/components/zs-components/global/ZSIcon.vue'
// import Accordion from '@/components/zs-components/Accordion.vue'

import { useUserStore } from "@/stores/user";
import { useLicenseStore } from '@/stores/license';
import { storeToRefs } from "pinia";
import TagPanel from '../../../layout/navigation/TagPanel.vue';
const userStore = useUserStore();
const { user, partner, partnerInfo } = storeToRefs(userStore);
import notificationService from '@/services/notification'

const { t } = useI18n();

const lic = useLicenseStore()

const props = defineProps({
    collapsed: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['linkClicked', 'openMoodleWizard'])


const route = useRoute();
const hasNewHardware = ref(false);
const isSelected = (path) => {
    return route.path === path;
};

const showNotification = async () => {
    try {
        await notificationService.show("Novo pedido de hardware", {
            body: "um novo pedido de hardware foi realizado"
        });
    } catch (error) {
        console.error("Failed to show notification:", error);
        // Fallback to alert if notification fails
        alert("Novo pedido de hardware: um novo pedido de hardware foi realizado");
    }
}

const checkForNewHardwareRequests = async () => {
    try {
        let newHW = await lic.CheckForNewHardwareRequests()
        if(newHW) {
            hasNewHardware.value = true
            await showNotification()
        }
    } catch (error) {
        console.error("Error checking for new hardware requests:", error);
    }
}

// let hardwareCheckInterval = null;

onMounted(async () => {
    // await notificationService.requestPermission();
    
    // // Initial check
    // if(user.value.admin){
    //     await checkForNewHardwareRequests();
        
    //     // Set up interval to check every 10 seconds
    //     hardwareCheckInterval = setInterval(checkForNewHardwareRequests, 60000 * 5);
    // }
})

// onUnmounted(() => {
//     // Clean up the interval when component is unmounted
//     if (hardwareCheckInterval) {
//         clearInterval(hardwareCheckInterval);
//         hardwareCheckInterval = null;
//     }
// });

const onRouterLinkClicked = () => {
    emit('linkClicked')
}

const onOpenMoodleWizard = () => {
    emit('linkClicked')
    emit('openMoodleWizard')
}

</script>

<style scoped>

    a {
    text-decoration: none;
    color: white;
  }
.navigation {
    display: flex;
    flex-direction: column;
    padding: 1em;
    transition: all 0.3s ease;

    .home-link {
        display: flex;
        align-items: center;
        gap: 15px;
        background-color: #D35400;
        padding: 15px 1em;
        color: white;
        text-decoration: none;
        border-radius: 5px;
        transition: all 0.3s ease;
        margin-bottom: 10px;

        &:hover {
            background-color: #c44a00;
        }

        &.selected {
            background-color: #a83a00;
        }
    }

    .nav-header {
        display: flex;
        gap: 15px;
        width: 100%;
        background-color: #D35400;
        padding: 15px 1em;
        color: white;
        border-radius: 5px;
        transition: all 0.3s ease;
        &[disabled=true]{
            opacity: 0.6;
            filter:grayscale()
        }
    }

    .nav-list {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 0 1em 1em 1em;
        transition: opacity 0.3s ease;

        a {
            color: white;
            text-decoration: none;
        }

        a:before {
            content: '-';
            padding-right: 1em;
            color: #EEEEEE;
            padding:0 10px;
        }
        a.selected{
            background-color:gray;
            border-radius: 5px;
        }
        a:hover{
            background-color:rgb(85, 85, 85);
            border-radius: 5px;
        }
    }
}

/* The parent anchor tag needs a relative position */
.notify {
  position: relative;
  display: inline-block; /* Ensures proper positioning of the pseudo-element */
  padding-right: 12px; /* Adds space for the dot */
}

/* Creates the small red circle */
.notify::after {
  content: '';
  position: absolute;
  top: 8px; /* Adjust as needed */
  right: 4px; /* Adjust as needed */
  width: 8px;
  height: 8px;
  background-color: orange;
  border-radius: 50%;
  box-shadow: 0 0 0 rgba(255, 0, 0, 0.4);
  animation: pulse 2s infinite;
}

/* Defines the pulsing animation */
@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 0, 0, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
  }
}
</style>
